module.exports = __webpack_public_path__ + "img/blue_silhouette.3026c374.png";